import { Maths } from '../_app/cuchillo/utils/Maths';
import HomeScene from '../3D/HomeScene';

// Sub-rang (dins del progrés 0→1 del MOVIMENT del helmet) on es revela el seu button-torcido.
// Així el button apareix a la segona part del recorregut del helmet.
const BUTTON_RANGE = [0.55, .85];

// Un HelmetHolder per .widget-home__item: "conté" un helmet (tapon 3D de HomeScene) + el seu
// button-torcido. loop(p) mou el helmet segons el progrés i, com a sub-rang, controla el
// show/hide del button-torcido. Rep la dada del button ja mesurada per ScrollItem__BlockDefault
// ({ btn, span, finalW }), perquè BlockDefault ja ha posat width:0 (no es pot re-mesurar aquí).
export default class HelmetHolder {
    constructor(buttonEntry, index) {
        this.index = index;                     // índex del tapon a HomeScene (mateix ordre DOM)
        this._btn = buttonEntry ? buttonEntry.btn : null;
        this._span = buttonEntry ? buttonEntry.span : null;
        this._btnW = buttonEntry ? buttonEntry.finalW : 0;

        this.hide(); // estat inicial: amagat
    }

    // Reveal del button-torcido mapejat (width màscara 0→final + opacity ràpida).
    _drawButton(p) {
        if (!this._btn) return;
        this._btn.style.width = `${p * this._btnW}px`;
        if (this._span) this._span.style.opacity = Maths.clamp(p * 4, 0, 1);
    }

    // p = progrés (0→1) del moviment del helmet. Mou el helmet 3D i, com a sub-rang, el button.
    loop(p) {
        HomeScene.setTaponProgress(this.index, p);
        const bp = Maths.clamp(Maths.normalize(BUTTON_RANGE[1], BUTTON_RANGE[0], p), 0, 1);
        this._drawButton(bp);
    }

    show() {
        HomeScene.setTaponProgress(this.index, 1);
        this._drawButton(1);
    }

    hide() {
        HomeScene.setTaponProgress(this.index, 0);
        this._drawButton(0);
    }
}
